import request from '@/utils/request'

/**
 * 人物分类
 * @param {*} data
 * @returns
 */
export function personCategory (data) {
  return request({
    url: '/zstp/neo4j/person_category/',
    method: 'post',
    data
  })
}

/**
 * 传记名称
 * @param {*} data
 * @returns
 */
export function biographieName (data) {
  return request({
    url: '/zstp/neo4j/biographie_name/',
    method: 'post',
    data
  })
}

/**
 * 宗派
 * @param {*} data
 * @returns
 */
export function allSect (data) {
  return request({
    url: '/zstp/neo4j/get_all_sect/',
    method: 'post',
    data
  })
}

/**
 * 朝代
 * @param {*} data
 * @returns
 */
export function allDynasty (data) {
  return request({
    url: '/zstp/neo4j/get_all_dynasty/',
    method: 'post',
    data
  })
}
